const menus = {
  Menu: {
    Dashboard: 'داشبورد',
    Profiles: 'پروفیل ها',
    Satchel: 'کارتابل',
    Projects: 'مدیریت پروژه ها',
    Coworkers: 'مدیریت  همکاران',
    Financial: 'مدیریت مالی',
    Reports: 'گزارش ها',
    Acl: 'مدیریت سطوح دسترسی',
    Settings: 'تنظیمات',
  },
}

export default menus
